var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.7578 26.9238C71.0913 35.7137 64.3145 49.0365 64.3145 64V448C64.3145 474.592 85.7225 496 112.314 496H437.195L197.266 256.072H447.686L81.7578 26.9238Z",
    fill: "#2B4896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9863 55.9121C86.5744 62.7782 84.0098 70.9541 84.0098 79.7559V432.244C84.0098 456.654 103.661 476.305 128.07 476.305H389.682L149.777 236.402H379.217L90.9863 55.9121Z",
    fill: "#E32D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.066 149.612L147.812 162.401C147.808 162.402 147.816 162.429 147.812 162.43H147.783L136.45 155.692L138.334 168.767L125.259 166.883L131.997 178.216L119.18 181.499L129.771 189.407C129.771 189.419 129.773 189.431 129.773 189.443L129.765 189.409L124.467 193.373C111.633 185.75 101.69 174.083 96.198 160.202C96.198 176.851 102.812 192.818 114.585 204.591C126.357 216.364 142.325 222.978 158.974 222.978C175.623 222.978 191.59 216.364 203.363 204.591C215.136 192.818 221.75 176.851 221.75 160.202C216.234 174.074 206.272 185.725 193.425 193.327L188.186 189.409L188.175 189.466C188.175 189.446 188.177 189.427 188.177 189.407L198.769 181.499L185.951 178.216L192.716 166.883L179.643 168.767L181.527 155.692L170.165 162.43L166.882 149.612L158.974 160.202L151.066 149.612H151.066Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.976 309.114L148.673 333.434L127.589 317.526L130.824 343.738L104.612 340.503L120.52 361.587L96.2002 371.89L120.52 382.196L104.612 403.279L130.824 400.042L127.589 426.257L148.672 410.348L158.976 434.666L169.281 410.348H169.208L169.328 410.321L169.281 410.348L190.365 426.257L187.13 400.042L213.342 403.279L197.434 382.196L221.754 371.89L197.434 361.587L213.342 340.503L187.13 343.738L190.365 317.526L169.282 333.435L158.976 309.114L158.976 309.114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/NP.da8fcf7e86a4a39cd94d8fd88dd9f01e.svg";
export { ForwardRef as ReactComponent };